Turbo.StreamActions.gtm_tag = function () {
  const page_url = this.getAttribute("page_url");
  const page_title = this.getAttribute("page_title") || "LivePocket Owner";
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "SPA_pageview",
    virtualPageUrl: page_url,
    virtualPageTitle: page_title,
  });
};
